module.exports = __webpack_public_path__ + "assets/img/wdgz.aaea7799.png";